import { PsqResults } from 'types/global'
import { PSQ_REQUESTED, PSQ_COMPLETED, PSQ_FAILED } from './../actions/psq-actions'
import { ActionType } from 'typesafe-actions'
import * as actions from 'actions/psq-actions'

type PsqAction = ActionType<typeof actions>

export type State = Readonly<{
  loading: boolean
  psqSubmitted: boolean
  psqResults?: PsqResults
  error?: string
}>

const initialState: State = {
  loading: false,
  psqSubmitted: false,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: PsqAction) => {
  switch (action.type) {
    case PSQ_REQUESTED:
      return { ...state, loading: true }
    case PSQ_COMPLETED:
      return { ...state, psqResults: action.payload, loading: false, psqSubmitted: true }
    case PSQ_FAILED:
      return { ...state, loading: false, psqSubmitted: true, error: action.payload.message }
    default:
      return state
  }
}
